<template src="./index.html"></template>
<script>
import data from './data.js';
import {page, loadTaxMyTodoTask} from '@/api/todo';
export default {
    data: function() {
        return {
            tableKey: 'todo-table',
            tableHeadData: data.configHeadData,
            tablePagination: data.tablePagination,
            tableData:[],
            searchlist: data.searchlist,
            searchdata: data.searchdata,
        }
    },
    created: function() {

    },
    mounted: function() {
        this.initTableData();
    },
    methods: {
        submitSearch(){
            this.initTableData();
        },
        selectSizeChange(e){
            this.tablePagination.pageSize = e;
            this.initTableData();
        },
        selectCurrentChange(e) {
            this.tablePagination.pageNum = e;
            this.initTableData();
        },
        initTableData(){
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.tablePagination.pageNum;
            params.size = this.tablePagination.pageSize;
            params.deadline = this.searchdata.deadline.join(",")
            page(params).then(res => {
                this.tableData = res.data.data.records;
                this.tablePagination.total = res.data.data.total;
                this.tablePagination.current = res.data.data.current;
                this.tablePagination.size = res.data.data.size;
            });
        },
        taxDownload(){
            loadTaxMyTodoTask().then(res => {
                this.$message.success("下载中，请稍后！");
            });
        },
    },
}
</script>
